const t = { last_updated: "Sist oppdatert", Series_type: "Serie", "How to guide_type": "Veiledning", FAQ_type: "Standard" }, e = {
  articles: t
};
export {
  t as articles,
  e as default
};
//# sourceMappingURL=help-center-knowledge-anatomies39.js.map
